import api from "!../../../../node_modules/_style-loader@2.0.0@style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../node_modules/_mini-css-extract-plugin@1.6.2@mini-css-extract-plugin/dist/loader.js??ref--2-2!../../../../node_modules/_css-loader@5.0.0@css-loader/dist/cjs.js??ref--2-3!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/loaders/stylePostLoader.js!../../../../node_modules/_postcss-loader@4.3.0@postcss-loader/dist/cjs.js!../../../../node_modules/_sass-loader@10.5.2@sass-loader/dist/cjs.js!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/index.js??vue-loader-options!./HoverDot.vue?vue&type=style&index=0&id=cf036f36&prod&lang=scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};